import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import {getNewsList} from '../../actions';
import NewsListItem from './NewsListItem';
import NewsListItemPlaceholder from './NewsListItemPlaceholder';
import LoadingSpinner from '../../../Layout/components/LoadingSpinner';
import Button from '@material-ui/core/Button';
import {withLocalize, Translate} from 'react-localize-redux';
import translations from '../../translations/translations_news_list';
import Waypoint from 'react-waypoint';

const NUMBER_ITEMS_PER_LINE = 4;
const NUMBER_ITEMS_PLACEHOLDER_INITIAL_LOADING = 8;

class NewsList extends Component {
    state = {
        initialLoad: true,
    };

    constructor(props) {
        super(props);

        this.props.addTranslation(translations);
    }

    fetchContent() {
        const {loading} = this.props;

        if (!loading) {
            this.props.getNewsList(
                1, // No offset
                true, // Reset the search results / listing
            );
        }
    }

    componentDidMount() {
        this.fetchContent();
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.languages !== this.props.languages) {
            const {pathname} = this.props.location;
            const expectedUri = this.props.translate('routes.news');

            if (pathname !== expectedUri) {
                this.props.history.push(expectedUri);
            } else {
                this.fetchContent();
            }
        }
    }

    handleScrollLoadMore = () => {
        this.loadMore();
    };

    handleClickLoadMore = (e) => {
        e.preventDefault();

        this.loadMore();
    };

    loadMore = (e) => {
        const {loading, hasMore, currentPage} = this.props;

        if (hasMore && !loading) {
            this.setState({initialLoad: false});

            this.props.getNewsList(currentPage + 1);
        }
    };

    render() {
        const {items, loading, hasMore} = this.props;

        let placeholders = [];
        let placeholders2 = [];

        if (this.state.initialLoad) {
            for (let i = 0; i < NUMBER_ITEMS_PLACEHOLDER_INITIAL_LOADING; i++) {
                placeholders.push(<NewsListItemPlaceholder key={i}/>);
            }
        } else {
            for (let i = 0; i < NUMBER_ITEMS_PER_LINE; i++) {
                placeholders2.push(<NewsListItemPlaceholder key={i}/>);
            }
        }

        return (
            <section id="news-list">
                <div className="row">
                    {(this.state.initialLoad && loading && Array.isArray(items) && items.length === 0) && placeholders}
                    {items.map(news => (
                        <NewsListItem key={news.id} news={news}/>
                    ))}
                    {(loading && !this.state.initialLoad) && placeholders2}
                    {(!loading && items.length === 0) &&
                        <div className="col col-12 text-center">
                            <p><Translate id="news_list.no_item_found" /></p>
                        </div>
                    }
                </div>
                {(hasMore && !loading) &&
                    <div className="row row-more">
                        <div className="col-lg-3 col-md-6 col-sm-12 mx-auto">
                            <div className="text-center">
                                <Waypoint onEnter={this.handleScrollLoadMore} />
                                <Button variant="contained" color="primary" size="medium" onClick={this.handleClickLoadMore} className="btn-more">
                                    <Translate id="news_list.button_load_more" />
                                </Button>
                            </div>
                        </div>
                    </div>
                }
                {((Array.isArray(items) && items.length === 0 || loading) && !this.state.initialLoad) &&
                    <div className="row row-loading">
                        <div className="col-lg-3 col-md-6 col-sm-12 mx-auto">
                            <div className="text-center">
                                <LoadingSpinner/>
                            </div>
                        </div>
                    </div>
                }
            </section>
        );
    }
}

NewsList.propTypes = {
    getNewsList: PropTypes.func.isRequired,
    translate: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
    loading: state.news.newsListLoading,
    hasMore: state.news.hasMore,
    currentPage: state.news.currentPage,
    items: state.news.newsList,
});

export default withRouter(connect(mapStateToProps, {getNewsList})(withLocalize(NewsList)));



// WEBPACK FOOTER //
// ./src/features/News/components/List/NewsList.js